import Grid from "@mui/material/Grid";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getSingleMachine } from "../../actions/machines";
import Documentation from "./_tabs/Documentation/DocumentationTab";
import History from "./_tabs/History/HistoryTab";
import InnerOverview from "./_tabs/Overview/InnerOverview.js";
import { ReactComponent as Magnifier } from "../../assets/magnifier.svg";

import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Lightbox } from "react-modal-image";
import CreateIcon from "@mui/icons-material/Create";
import { ReactComponent as RoundedDeleteSvg } from "../../assets/roundedDelete.svg";

import { LocationOn } from "@mui/icons-material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AppBar from "@mui/material/AppBar";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Paper from "@mui/material/Paper/Paper";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography/Typography";
import clsx from "clsx";
import FactoryIcon from "mdi-react/FactoryIcon";
import { useDispatch, useStore } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { makeStyles } from "tss-react/mui";
import { GetAllCategories } from "../../actions/objects";
import machineFallbackImage from "../../assets/machine-example.png";
import TabPanel from "../../components/TabPanel";
import { Theme247 } from "../../styles/Theme247";
import { ApplyStyle as _s } from "../../utils/ApplyStyle";
import Faq from "./_tabs/FAQ/Faq";
import Maintenance from "./_tabs/Maintenance/maintenance";
import Counters from "./_tabs/counters/counters.js";
import {
  Box,
  Divider,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  MenuList,
  Skeleton,
  Stack,
  Zoom,
} from "@mui/material";
import { canUserPerformAction } from "../../shared-functions/userrights";
import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";

import { ReactComponent as Small123 } from "../../assets/small123.svg";
import { ReactComponent as SmallMachine } from "../../assets/smallMachine.svg";
import { ReactComponent as SmallVector } from "../../assets/smallVector.svg";
import { ReactComponent as SmallLabel } from "../../assets/smallLabel.svg";

import { EmptyState } from "./EmptyStat";
import { setActiveCopilotId, updateCopilot } from "../../actions/ui";

import { ReactComponent as WhiteAgentSvg } from "../../assets/GrayAgentSvg.svg";

import { deletemachine } from "../../actions/machines";

import { getsitesareaeqs2, getallsitesareaeqs } from "../../actions/objects";
import { isArray } from "lodash";
import DeletePopUp from "../../components/DeletePopup";

var doOnce = true;

let isCopilotInitiated = false;

export default connect(
  ({ machines, i18n, profile, activeCopilotNodeIds, activeCopilotNodeid }) => ({
    machines,
    i18n,
    profile,
    activeCopilotNodeIds,
    activeCopilotNodeid,
  }),
  {
    getSingleMachine,
    GetAllCategories,
    updateCopilot,
    getsitesareaeqs2,
    deletemachine,
    setActiveCopilotId,
  }
)((props) => {
  const i18n = props.i18n;

  const [poolname, setpoolname] = useState();

  const [openDialogDelete, setOpenDialogDelete] = useState(false);

  /* const [internalAttachments,setinternalAttachments]=useState();
	 const [manufacturerAttachments,setmanufacturerAttachments]=useState();*/

  let location = useLocation(); // 0 or 130   fro margin-left active div
  const dispatch = useDispatch();

  // console.log(props, "props,,,,");

  const [isOpen, setisOpen] = useState(false);
  const [large, setlarge] = useState("");

  const store = useStore().getState();

  const params = new URLSearchParams(location.search);
  let nodeid = params.get("nodeid");
  const tab = params.get("tab");

  nodeid = nodeid?.split("&")[0];

  useEffect(() => {
    dispatch({ type: "CLEARMACHINE", payload: {} });
    setActiveTab(Number(tab));
    if (tab == "3") {
      setTimeout(function() {
        props.getSingleMachine(nodeid);
      }, 2000);
    }
    if (tab == "4") {
      setTimeout(function() {
        props.getSingleMachine(nodeid);
      }, 2000);
    }
    props.getSingleMachine(
      location?.state != undefined ? location?.state?.nodeid : nodeid
    );
    props.GetAllCategories("", "GETALLCATEGORIES");
  }, [location.state, location.search]);

  const { machines } = props;
  var filteredPool = "";
  var filteredMachine = "";
  if (location?.state && location?.state?.from === "area") {
    filteredMachine = location?.state?.area.area.hasequipment.filter(
      (m) => m.equipment.nodeid == location?.state?.nodeid
    );
  } else if (location?.state && location?.state?.from === "notification") {
    filteredMachine = location?.state?.equipment;
  }

  useEffect(() => {
    filteredMachine = props.machines;

    if (filteredMachine.equipment !== undefined) {
      setTimeout(() => {
        document
          .getElementById("allnotis")
          ?.scrollIntoView({ behavior: "smooth" });
      }, 1000);
    }
  }, [machines]);

  useEffect(() => {
    isCopilotInitiated = false;

    dispatch({ type: "CLEARNOTIFICATION", payload: {} });

    return () => {
      props.setActiveCopilotId("");
    };
  }, []);

  useEffect(() => {
    if (props.machines.equipment && !isCopilotInitiated) {
      isCopilotInitiated = true;
      handleClickCopilot();
    }
  }, [props.machines]);

  /*
   * Tabs
   */
  const [activeTab, setActiveTab] = React.useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleDialogDelete = () => {
    setOpenDialogDelete(false);
  };

  /*
   * Styles
   */
  const useStyles = makeStyles()(() => ({
    sectionHeader: {
      padding: "0 !important",
      alignItems: "normal",
    },
    moreFilterButton: {
      position: "relative",
      display: "inline-flex",
      marginLeft: Theme247.spacing(2),
      marginTop: 0,
    },
    sectionMainContainer: {
      display: "flex",
      flexDirection: "column",
      width: "60%",
      color: "#ffffff",
    },
    equipmentNameContainer: {
      display: "flex",
      justifyContent: "space-between",
      flexGrow: 1,
      padding: "28px 24px 20px 24px",
    },
    equipmentStatisticsContainer: {
      flexGrow: 1,
      backgroundColor: "rgba(255, 255, 255, 0.1)",
      padding: "20px 24px 28px 24px",
    },
    smallCaption: {
      ...Theme247.typography.small_caption,
      ...Theme247.typography.white_60,
      //   marginBottom: 14,
    },
    optionsButtonContainer: {
      marginTop: -12,
      marginLeft: 24,
    },
    equipmentPhoto: {
      width: "40%",
      maxHeight: 248,
      position: "relative",

      "&.MuiGrid-root": {
        paddingTop: 0,
        paddingBottom: 0,
      },

      "& img": {
        width: "100%",
        height: "100%",
        objectFit: "fill",
      },
    },
  }));
  const { classes } = useStyles();

  // useEffect(() => {
  // 	return () => {
  // 		dispatch({ type: 'CLEARMACHINE', payload: {} });
  // 	}
  // }, []);

  const myClasses = {
    breadcrumbs: _s(Theme247.breadcrumbs),
    sectionContainer: _s(Theme247.sectionContainer),
    sectionHeaderPrimary: _s(Theme247.sectionHeaderPrimary),
    typographyRegular: _s(Theme247.typography.regular),
    tabsContainer: _s(Theme247.tabsContainer),
  };

  const [anchorEl, setanchorEl] = useState();
  const [open, setopen] = useState(false);
  const handleClick = (event) => {
    setanchorEl(event.currentTarget);
    setopen(true);
  };
  const handleClose = () => {
    setanchorEl(null);
    setopen(false);
  };

  const handleClickCopilot = () => {
    let nodeid = location?.state?.nodeid;
    dispatch(setActiveCopilotId(nodeid ? nodeid : params.get("nodeid")));

    // $(".copilot_dialog").toggle();
    // $(".cpSideViewChat").toggle();
    // $(".mainNavigationWrapper").toggle();
    // $(".mainNavigationSideViewWrapper").toggle();
  };

  const navigate = useNavigate();

  const handleDelete = () => {
    setOpenDialogDelete(true);
  };

  const handleDeleteMachine = async () => {
    const nodeid = location?.state?.nodeid;
    props.deletemachine({ nodeid });
    setTimeout(() => {
      props.getsitesareaeqs2("", "SAE2");
    }, 2000);
    navigate("/dashboard");
  };

  const onImgClick = (e, url) => {
    e.preventDefault();
    setisOpen(true);
    setlarge(url);
  };

  const closeLightbox = () => {
    setisOpen(false);
  };

  return (
    <>
      <DeletePopUp
        open={openDialogDelete}
        handleClose={handleDialogDelete}
        handleDelete={handleDeleteMachine}
        topic={"Maschine"}
      ></DeletePopUp>

      {isOpen && (
        <Lightbox
          large={large}
          alt={i18n.image_here}
          hideZoom={false}
          showRotate={true}
          onClose={closeLightbox}
        />
      )}

      {location?.state && location?.state?.from === "site" ? (
        // eslint-disable-next-line
        <Breadcrumbs aria-label="breadcrumb" className={myClasses.breadcrumbs}>
          <Link to={"/sites/" + encodeURIComponent(location?.state.sitenodeid)}>
            <ArrowBackIcon size="large" />
            {i18n.tab_dashboard}
          </Link>
        </Breadcrumbs>
      ) : location?.state && location?.state?.from === "machines" ? (
        // eslint-disable-next-line
        <Breadcrumbs aria-label="breadcrumb" className={myClasses.breadcrumbs}>
          <Link to={"/machines"}>
            <ArrowBackIcon size="large" />
            {i18n.tab_dashboard}
          </Link>
        </Breadcrumbs>
      ) : location?.state && location?.state?.from === "area" ? (
        // eslint-disable-next-line
        <Breadcrumbs aria-label="breadcrumb" className={myClasses.breadcrumbs}>
          <Link to="/dashboard">
            <ArrowBackIcon size="large" />
            {i18n.tab_dashboard}
          </Link>
        </Breadcrumbs>
      ) : location?.state && location?.state?.from === "mb" ? (
        // eslint-disable-next-line
        <Breadcrumbs aria-label="breadcrumb" className={myClasses.breadcrumbs}>
          <Link to="/types-machines">
            <ArrowBackIcon size="large" />
            {i18n.tab_dashboard}
          </Link>
        </Breadcrumbs>
      ) : location?.state && location?.state?.isFiltered == true ? (
        // eslint-disable-next-line
        <Breadcrumbs aria-label="breadcrumb" className={myClasses.breadcrumbs}>
          <Link to="/dashboard">
            <ArrowBackIcon size="large" />
            {i18n.tab_dashboard}
          </Link>
        </Breadcrumbs>
      ) : (
        // eslint-disable-next-line
        <Breadcrumbs aria-label="breadcrumb" className={myClasses.breadcrumbs}>
          <Link
            to={
              location?.state && location?.state?.from === "area"
                ? "/dashboard"
                : location?.state?.from === "mb"
                ? "/types-machines"
                : "/dashboard"
            }
          >
            <ArrowBackIcon size="large" />
            {i18n.tab_dashboard}
          </Link>
        </Breadcrumbs>
      )}

      <section style={{ marginBottom: "35%" }}>
        <Paper
          elevation={Theme247.elevationLow}
          className={myClasses.sectionContainer}
        >
          {props.machines?.equipment === undefined ? (
            <div className="MO_Skeliton_Wrapper">
              {" "}
              <Box>
                <div className="MO_Skeliton">
                  <div>
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                  </div>
                  <div>
                    <Skeleton
                      animation="wave"
                      variant="rounded"
                      id="MO_Skeliton_Image"
                    />
                  </div>
                </div>
              </Box>
              <Divider />
              <Box>
                <Skeleton
                  animation="wave"
                  width={200}
                  variant="text"
                  sx={{ fontSize: "1rem", marginTop: "15px" }}
                />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "23px",
                  }}
                >
                  <Skeleton
                    variant="rounded"
                    width={424}
                    height={97}
                    animation="wave"
                  />
                  <Skeleton
                    variant="rounded"
                    width={424}
                    height={97}
                    animation="wave"
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "23px",
                  }}
                >
                  <Skeleton
                    variant="rounded"
                    width={424}
                    height={97}
                    animation="wave"
                  />
                  <Skeleton
                    variant="rounded"
                    width={424}
                    height={97}
                    animation="wave"
                  />
                </div>
              </Box>
            </div>
          ) : (
            <>
              <Grid
                container
                spacing={0}
                direction="row"
                alignItems="flex-start"
                className={clsx(
                  myClasses.sectionHeaderPrimary,
                  classes.sectionHeader
                )}
                id="allnotis"
              >
                <Grid
                  item
                  className={clsx(
                    myClasses.typographyRegular,
                    classes.sectionMainContainer
                  )}
                >
                  <div className={classes.equipmentNameContainer}>
                    <div>
                      {location?.state && location?.state?.from === "mb" ? (
                        <Typography variant="h1" color="inherit">
                          {location?.state?.typename}
                          <span> COpilot</span>
                          <br />

                          <span className={myClasses.typographyRegular}>
                            {i18n.customer_equipments}
                          </span>
                        </Typography>
                      ) : (
                        <Typography
                          variant="h1"
                          color="inherit"
                          style={{ marginBottom: 20 }}
                        >
                          {props.machines?.equipment?.name &&
                            props.machines?.equipment?.name}

                          {/* copilot implementation */}

                          {/* <span
                            className="mo_copilot"
                            onClick={handleClickCopilot}
                          >
                            {" "}
                            <WhiteAgentSvg /> <span>Copilot</span>{" "}
                          </span> */}

                          <br />

                          <span
                            className={myClasses.typographyRegular}
                            style={{ marginTop: 7, position: "absolute" }}
                          >
                            {props.machines?.equipment?.hasequipmenttype &&
                              props.machines?.equipment?.hasequipmenttype[0]
                                ?.equipmenttype?.isequipmenttypeof[0]?.brand
                                ?.name}

                            <span style={{ marginLeft: 5 }}>
                              {props.machines?.equipment?.hasequipmenttype &&
                                props.machines?.equipment?.hasequipmenttype[0]
                                  ?.equipmenttype?.model}
                            </span>
                          </span>
                        </Typography>
                      )}
                    </div>
                    <div>
                      {canUserPerformAction(
                        props.profile?.features?.equipment,
                        "update"
                      ) && (
                        <div
                          className={classes.optionsButtonContainer}
                          style={{ marginLeft: "0px" }}
                        >
                          <IconButton
                            className={classes.moreFilterButton}
                            aria-label="more"
                            sx={{ color: "#ffffff" }}
                            aria-controls="long-menu"
                            aria-haspopup="true"
                            onClick={handleClick}
                            style={{ paddingRight: "0px" }}
                          >
                            <MoreVertIcon />
                          </IconButton>
                          <Menu
                            id="long-menu"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            // getContentAnchorEl={null}
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "right",
                            }}
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "right",
                            }}
                            keepMounted
                          >
                            <MenuList className="mo_menu">
                              <MenuItem>
                                <Typography variant="inherit">
                                  <Link
                                    to="/create-machine"
                                    state={{
                                      equipment: props.machines?.equipment,
                                      enterprises: props.enterprises,
                                      sitenodeid: location?.state?.sitenodeid,
                                      pageType: "edit",
                                    }}
                                    style={{ display: "flex" }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        margin: "10px",
                                        alignItems: "center",
                                      }}
                                    >
                                      <div>
                                        <ListItemIcon sx={{ color: "#38748D" }}>
                                          <ModeEditOutlinedIcon fontSize="small" />
                                        </ListItemIcon>
                                      </div>
                                      <div style={{ marginLeft: "-11px" }}>
                                        {"BEARBEITEN"}
                                      </div>
                                    </div>
                                  </Link>
                                </Typography>
                              </MenuItem>

                              {canUserPerformAction(
                                props.profile?.features?.equipment,
                                "delete"
                              ) && (
                                <MenuItem id="1" onClick={handleDelete}>
                                  <div
                                    className="menuItem"
                                    style={{ display: "flex", padding: "5%" }}
                                  >
                                    <div className="icon">
                                      <RoundedDeleteSvg />
                                    </div>
                                    <div
                                      className="text"
                                      style={{
                                        color: "#38748d",
                                        opacity: "1",
                                        fontSize: "16px",
                                      }}
                                    >
                                      {" "}
                                      löschen
                                    </div>
                                  </div>
                                </MenuItem>
                              )}
                            </MenuList>
                          </Menu>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className={classes.equipmentStatisticsContainer}>
                    {location?.state?.from === "area" ? (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          flexWrap: "wrap",
                          columnGap: "15px",
                        }}
                      >
                        <Typography
                          style={{
                            height: 28,
                            width: "50%",
                            fontSize: 12,
                            letterSpacing: 0.5,
                            fontFamily: "Roboto",
                            display: "flex",
                            alignItems: "center",
                          }}
                          variant="caption"
                          className={classes.smallCaption}
                          component="div"
                        >
                          <SmallMachine width={16} height={16} />
                          <div
                            style={{
                              marginTop: 3,
                              marginLeft: 5,
                            }}
                          >
                            {props.machines?.equipment &&
                            props.machines?.equipment?.isequipmentof &&
                            props.machines?.equipment?.isequipmentof[0]
                              ?.equipmentpool !== undefined
                              ? props.machines?.equipment?.isequipmentof[0]
                                  ?.equipmentpool.name
                              : props.machines?.equipment?.isequipmentof[0]
                                  ?.area?.name}
                            -
                            {props.machines?.equipment &&
                            props.machines?.equipment?.isequipmentof &&
                            props.machines?.equipment?.isequipmentof[1]
                              ? props.machines?.equipment?.isequipmentof[1]
                                  ?.area?.name
                              : props.machines?.equipment?.isequipmentof[0]
                                  ?.area?.name}
                          </div>
                        </Typography>
                        <Typography
                          style={{
                            height: 28,
                            width: "50%",
                            fontSize: 12,
                            letterSpacing: 0.5,
                            fontFamily: "Roboto",
                            display: "flex",
                            alignItems: "center",
                          }}
                          variant="caption"
                          className={classes.smallCaption}
                          component="div"
                        >
                          <span
                            style={{
                              marginTop: 3,
                              width: "250px",
                            }}
                          >
                            <SmallVector
                              style={{ marginRight: "2%" }}
                              width={16}
                              height={16}
                            />{" "}
                            {props.machines?.equipment &&
                            props.machines?.equipment?.isequipmentof &&
                            props.machines?.equipment?.isequipmentof[1]
                              ? props.machines?.equipment?.isequipmentof[1]
                                  ?.area?.isareaof[0]?.site?.name
                              : props.machines?.equipment?.isequipmentof[0]
                                  ?.area?.isareaof[0]?.site?.name}
                          </span>
                        </Typography>
                        <Typography
                          style={{
                            height: 28,
                            width: "fit-content",
                            fontSize: 12,
                            letterSpacing: 0.5,
                            fontFamily: "Roboto",
                            marginTop: 4,
                            marginRight: 10,
                            display: "flex",
                            alignItems: "center",
                          }}
                          variant="caption"
                          className={classes.smallCaption}
                          component="div"
                        >
                          <SmallLabel width={16} height={16} />
                          <div
                            style={{
                              marginTop: 0,
                              marginLeft: 5,
                            }}
                          >
                            {"Equipment ID  : "}{" "}
                            {props?.machines?.equipment?.equipmentid}
                          </div>
                        </Typography>
                        <Typography
                          style={{
                            height: 28,
                            width: "50%",
                            fontSize: 16,
                            letterSpacing: 0.5,
                            fontFamily: "Roboto",
                            display: "flex",
                            alignItems: "center",
                          }}
                          variant="caption"
                          className={classes.smallCaption}
                          component="div"
                        >
                          <div
                            style={{
                              marginTop: 4,
                              fontSize: 12,
                              width: "250px",
                            }}
                          >
                            <Small123
                              style={{ marginRight: "2%" }}
                              width={16}
                              height={16}
                            />
                            {"Inventory ID  : "}
                            {props.machines?.equipment?.inventoryid}
                          </div>
                        </Typography>
                      </div>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          flexWrap: "wrap",
                          columnGap: "15px",
                        }}
                      >
                        {props.machines?.equipment?.isequipmentof !==
                        undefined ? (
                          <>
                            <Typography
                              style={{
                                height: 28,
                                width: "fit-content",
                                fontSize: 12,
                                letterSpacing: 0.5,
                                fontFamily: "Roboto",
                                marginRight: 10,
                                display: "flex",
                                alignItems: "center",
                              }}
                              variant="caption"
                              className={classes.smallCaption}
                              component="div"
                            >
                              <SmallMachine width={16} height={16} />
                              <div
                                style={{
                                  marginTop: 2,
                                  marginLeft: 7,
                                }}
                              >
                                {props.machines?.equipment &&
                                props.machines?.equipment?.isequipmentof &&
                                props.machines?.equipment?.isequipmentof[0]
                                  ?.equipmentpool !== undefined
                                  ? props.machines?.equipment?.isequipmentof[0]
                                      ?.equipmentpool.name
                                  : props.machines?.equipment?.isequipmentof[0]
                                      ?.area?.name}
                              </div>
                            </Typography>
                            <Typography
                              style={{
                                height: 28,
                                width: "50%",
                                fontSize: 12,
                                letterSpacing: 0.5,
                                fontFamily: "Roboto",
                                display: "flex",
                                alignItems: "center",
                              }}
                              variant="caption"
                              className={classes.smallCaption}
                              component="div"
                            >
                              <div
                                style={{
                                  width: "250px",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <SmallVector
                                  style={{ marginRight: "2%" }}
                                  width={16}
                                  height={16}
                                />
                                <div>
                                  {props.machines?.equipment &&
                                  props.machines?.equipment?.isequipmentof &&
                                  props.machines?.equipment?.isequipmentof[1]
                                    ? props.machines?.equipment
                                        ?.isequipmentof[1]?.area?.isareaof[0]
                                        ?.site?.name
                                    : props.machines?.equipment
                                        ?.isequipmentof[0]?.area?.isareaof[0]
                                        ?.site?.name}
                                </div>
                              </div>
                            </Typography>
                            <Typography
                              style={{
                                height: 28,
                                width: "fit-content",
                                fontSize: 12,
                                letterSpacing: 0.5,
                                fontFamily: "Roboto",
                                marginRight: 10,
                                display: "flex",
                                alignItems: "center",
                              }}
                              variant="caption"
                              className={classes.smallCaption}
                              component="div"
                            >
                              {props?.machines?.equipment?.equipmentid ? (
                                <>
                                  <SmallLabel
                                    style={{ marginTop: "" }}
                                    width={16}
                                    height={16}
                                  />
                                  <div
                                    style={{
                                      marginLeft: 5,
                                    }}
                                  >
                                    {"Equipment ID : "}{" "}
                                    {props?.machines?.equipment?.equipmentid}
                                  </div>
                                </>
                              ) : (
                                <>
                                  {" "}
                                  <SmallLabel width={16} height={16} />{" "}
                                </>
                              )}
                            </Typography>
                            <Typography
                              style={{
                                height: 28,
                                width: "50%",
                                fontSize: 12,
                                letterSpacing: 0.5,
                                fontFamily: "Roboto",
                                display: "flex",
                                alignItems: "center",
                              }}
                              variant="caption"
                              className={classes.smallCaption}
                              component="div"
                            >
                              <Small123
                                style={{ marginRight: "2%" }}
                                width={16}
                                height={16}
                              />
                              <div>
                                {"Inventory ID  : "}
                                {props.machines?.equipment?.inventoryid}
                              </div>
                            </Typography>
                          </>
                        ) : (
                          ""
                        )}
                      </div>
                    )}
                  </div>
                </Grid>

                <Grid item className={classes.equipmentPhoto}>
                  <img
                    src={
                      props?.machines?.equipment?.image &&
                      Object.keys(props?.machines?.equipment?.image)?.length !==
                        0 &&
                      !isArray(props?.machines?.equipment?.image) &&
                      props.machines?.equipment?.image != null &&
                      props.machines?.equipment.image.fileid != ""
                        ? props.machines?.equipment?.image?.url
                        : machineFallbackImage
                    }
                    alt={
                      props.machines?.equipment?.name != undefined
                        ? props.machines?.equipment?.name
                        : props.machines?.equipment?.name
                    }
                  />
                  <Zoom in timeout={1000}>
                    <div
                      className="eqMagnifier magnifier"
                      style={{
                        top: "80%",
                        left: "86%",
                        position: "absolute",
                      }}
                    >
                      <Magnifier
                        onClick={(e) => {
                          onImgClick(
                            e,
                             props.machines?.equipment?.image != null &&
                            !isArray(props.machines.equipment.image) &&
                              props.machines?.equipment.image.fileid != ""
                              ? props.machines?.equipment?.image?.url
                              : machineFallbackImage
                          );
                        }}
                      />
                    </div>
                  </Zoom>
                </Grid>
              </Grid>

              <Grid
                container
                spacing={3}
                direction="row"
                className={myClasses.tabsContainer}
              >
                <Grid item xs={12}>
                  <AppBar position="static">
                    <Tabs
                      className="MO_tabs"
                      value={activeTab}
                      onChange={handleTabChange}
                    >
                      <Tab
                        label={i18n.tab_overview}
                        sx={{ color: "inherit", letterSpacing: 1 }}
                      />
                      <Tab label={i18n.tab_history} sx={{ color: "inherit", letterSpacing: 1 }} />
                      <Tab
                        label={i18n.tab_documentation}
                        sx={{ color: "inherit", letterSpacing: 1 }}
                      />
                      <Tab label={i18n.tab_faq} sx={{ color: "inherit", letterSpacing: 1 }} />
                      <Tab
                        label={i18n.tab_maintenance}
                        sx={{ color: "inherit", letterSpacing: 1 }}
                      />
                      <Tab
                        label={i18n.tab_counters}
                        sx={{ color: "inherit", letterSpacing: 1 }}
                      />
                    </Tabs>
                  </AppBar>
                  <TabPanel value={activeTab} index={0}>
                    <InnerOverview
                      poolname={poolname}
                      machines={props.machines?.equipmet}
                      from={location?.state?.from}
                      nodeid={location?.state?.nodeid}
                      srno={location?.state?.srno}
                      c_yr={location?.state?.c_yr}
                    />
                  </TabPanel>
                  <TabPanel value={activeTab} index={1}>
                    <History />
                  </TabPanel>
                  <TabPanel value={activeTab} index={2}>
                    <Documentation />
                  </TabPanel>
                  <TabPanel value={activeTab} index={3}>
                    <Faq />
                  </TabPanel>
                  <TabPanel value={activeTab} index={4}>
                    <Maintenance />
                  </TabPanel>
                  <TabPanel value={activeTab} index={5}>
                    <Counters machines={props.machines} />
                  </TabPanel>
                </Grid>
              </Grid>
            </>
          )}
        </Paper>
      </section>
    </>
  );
});
